var video, playActivationArea;
var videoPlaying = false;
document.querySelectorAll('.inlineVideoPlayer').forEach(function (videoPlayer) {
  video = videoPlayer.getElementsByClassName('inlineVideo')[0];
  playActivationArea =
    videoPlayer.getElementsByClassName('playActivationArea')[0];
  if (playActivationArea) {
    playActivationArea.addEventListener('click', toggleVideo);
  }
});

function toggleVideo() {
  if (videoPlaying == false) {
    videoPlaying = true;
    playVideo();
  } else {
    videoPlaying = false;
    pauseVideo();
  }
}

function playVideo() {
  video.play();
}

function pauseVideo() {
  video.pause();
}
